import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import LayoutOptions from "./components/LayoutOptions";
import Div from "@jumbo/shared/Div";
import useApp from "../../hooks/useApp";
import MainThemeOptions from "./components/MainThemeOptions";
import Stack from "@mui/material/Stack";
import HeaderOptions from "./components/HeaderOptions";
import SidebarOptions from "./components/SidebarOptions";
import FooterOptions from "./components/FooterOptions";
import LocalizationOptions from "./components/LocalizationOptions";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import ThemeModeOption from "./components/ThemeModeOptions/ThemeModeOption";
import { useSelector } from "react-redux";
import { Autocomplete, TextField, Button, Checkbox } from "@mui/material";
import cloneDeep from "lodash.clonedeep";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { dispatch } from "app/store/store";
import {
  GetGlobalAccountsFilterList,
  GetGlobalAdvertisersFilterList,
  getGlobalBannersListThunk,
  getGlobalCampaignsListThunk,
} from "app/store/slice/common-slice";
import debounce from "lodash/debounce";
import {
  updateReportingFilters,
  updateReportingFiltersFormValues,
} from "app/store/slice/report-slice";
import { CenterFocusWeakTwoTone } from "@mui/icons-material";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint } from "app/utils/constants/paths";
import {
  updateCampaignFilters,
  updateCampaignFiltersFormValues,
} from "app/store/slice/campaign-slice";
import VirtualizeAutocomplete from "app/Common/VirtualizeAutocomplete";
import {
  updateAdvertiserFilters,
  updateAdvertiserFiltersFormValues,
} from "app/store/slice/advertiser-slice";

const AdvertiserFiltersCustomizer = () => {
  // const theme = useJumboTheme();
  const { customizerVisibility, setCustomizerVisibility } = useApp();
  const {
    globalAccountsList,
    globalAdvertisersList,
    authUserData,
    globalCompaniesList,
  } = useSelector((state) => state.CommonReducer);

  const { advertiserFilterFormValues } = useSelector(
    (state) => state.AdvertiserReducer
  );

  // console.log("Advertiser Filters:", advertiserFilterFormValues);

  const [formValues, setFormValues] = useState({
    organizations: {
      source: globalCompaniesList, //globalFilterAccountsList
      value: advertiserFilterFormValues.organizations,
    },
    accounts: {
      source: globalAccountsList, //globalFilterAccountsList
      value: advertiserFilterFormValues.accounts,
    },
    advertisers: {
      source: globalAdvertisersList, //globalFilterAdvertisersList,
      value: advertiserFilterFormValues.advertisers,
    },
  });

  //console.log("formValues", formValues);

  useEffect(() => {
    filterChildDropDown(
      "organizations",
      "accounts",
      "company_id",
      globalAccountsList
    );
  }, [formValues.organizations.value]);

  useEffect(() => {
    filterChildDropDown(
      "accounts",
      "advertisers",
      "account_id",
      globalAdvertisersList
    );
  }, [formValues.accounts.value]);
  // useEffect(() => {
  //   filterChildDropDown(
  //     "organizations",
  //     "accounts",
  //     "company_id",
  //     globalAccountsList
  //   );
  // }, [formValues.organizations.value]);

  const multiSelectChangeHandler = (name, value) => {
    let inputName = name;
    let inputValue = value != undefined && value != null ? value : "";
    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
      },
    }));
    dispatch(
      updateAdvertiserFiltersFormValues({ type: inputName, data: inputValue })
    );
  };

  const filterChildDropDown = (
    parentId,
    childId,
    childParentKey,
    childMasterData
  ) => {
    let selParentValuesArr = Array.isArray(formValues[parentId].value)
      ? formValues[parentId].value
      : [formValues[parentId].value];

    let selchildValuesArr = cloneDeep(formValues[childId].value);
    selchildValuesArr = Array.isArray(selchildValuesArr)
      ? selchildValuesArr
      : [];

    //console.log("Child Parent Key:", childParentKey);
    //console.log("Child Parent Values:", selParentValuesArr);

    if (selParentValuesArr <= 0) {
      selParentValuesArr = Array.isArray(formValues[parentId].source)
        ? formValues[parentId].source
        : [formValues[parentId].source];
    }

    let modChildList = childMasterData;
    //if (selParentValuesArr.length > 0) {
    modChildList = childMasterData.filter((item, index) => {
      return selParentValuesArr.some((v) => v.value == item[childParentKey]);
    });
    // }

    let selChildList = modChildList.filter((item, index) => {
      return selchildValuesArr.some((v) => v.value == item.value);
    });
    // console.log("modChildList", modChildList);
    let finalObj = {};
    finalObj = {
      ...formValues,
      [childId]: {
        ...formValues[childId],
        source: modChildList,
        value: selChildList,
      },
    };
    setFormValues(finalObj);
    //console.log("finalObjcc", finalObj);
  };

  const applyFilter = async (isClose = true) => {
    let accountsArr = [];
    let advertisersArr = [];
    let organizationsArr = [];

    //console.log("advertiserFilterFormValues:", advertiserFilterFormValues);
    advertiserFilterFormValues.organizations.map((orgInfo) => {
      organizationsArr.push(orgInfo.value);
    });
    advertiserFilterFormValues.accounts.map((accInfo) => {
      accountsArr.push(accInfo.value);
    });
    advertiserFilterFormValues.advertisers.map((advInfo) => {
      advertisersArr.push(advInfo.value);
    });

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      organizationsArr =
        organizationsArr.length > 0
          ? organizationsArr
          : globalCompaniesList.map((orgInfo) => {
              return orgInfo.value;
            });
      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });

      advertisersArr =
        advertisersArr.length > 0
          ? advertisersArr
          : globalAdvertisersList.map((advInfo) => {
              return advInfo.value;
            });
    }

    let selFilters = {
      organizations: organizationsArr,
      accounts: accountsArr,
      advertisers: advertisersArr,
    };

    dispatch(updateAdvertiserFilters(selFilters));

    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  const clearFilter = (isClose = true) => {
    let finalObj = cloneDeep(formValues);
    finalObj.organizations.value = [];
    finalObj.accounts.value = [];
    finalObj.advertisers.value = [];

    setFormValues(finalObj);

    dispatch(updateAdvertiserFiltersFormValues({ action: "delete" }));

    let organizationsArr = [];
    let accountsArr = [];
    let advertisersArr = [];

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      organizationsArr =
        organizationsArr.length > 0
          ? organizationsArr
          : globalCompaniesList.map((orgInfo) => {
              return orgInfo.value;
            });

      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });

      advertisersArr =
        advertisersArr.length > 0
          ? advertisersArr
          : globalAdvertisersList.map((advInfo) => {
              return advInfo.value;
            });
    }
    let selFilters = {
      organizations: organizationsArr,
      accounts: accountsArr,
      advertisers: advertisersArr,
    };
    dispatch(updateAdvertiserFilters(selFilters));
    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  //To Apply Filters
  useEffect(() => {
    applyFilter();
  }, []);

  return (
    <Drawer
      anchor={"right"}
      open={customizerVisibility}
      onClose={() => setCustomizerVisibility(false)}
      sx={{
        zIndex: 1205,

        "& .MuiDrawer-paper": {
          width: 336,
        },
      }}
    >
      <Div
        sx={{
          display: "flex",
          minWidth: 0,
          position: "relative",
          zIndex: 2,
          p: (theme) => theme.spacing(1.5, 3),
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: 25,
        }}
      >
        <Typography variant={"h3"} mb={0} sx={{ fontSize: "14px" }}>
          Filters
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setCustomizerVisibility(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Div>
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Stack sx={{ px: 3, pt: 2 }}>
          {(authUserData.is_sys_admin == "1" ||
            globalCompaniesList.length > 1) && (
            <VirtualizeAutocomplete
              id="Organization"
              label="Organizations"
              placeholder="Search Organization"
              list={globalCompaniesList}
              selectedValues={
                formValues.organizations.value != ""
                  ? formValues.organizations.value
                  : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="organizations"
            />
          )}

          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) && (
            <VirtualizeAutocomplete
              id="Account"
              label="Accounts"
              placeholder="Search Accounts"
              list={formValues.accounts.source}
              selectedValues={
                formValues.accounts.value != "" ? formValues.accounts.value : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="accounts"
            />
          )}

          {(authUserData.is_sys_admin == "1" ||
            globalAdvertisersList.length > 1) && (
            <VirtualizeAutocomplete
              id="Advertiser"
              label="Advertisers"
              placeholder="Search Advertisers"
              list={formValues.advertisers.source}
              selectedValues={
                formValues.advertisers.value != ""
                  ? formValues.advertisers.value
                  : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="advertisers"
            />
          )}
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ px: 3, pt: 2 }}
          spacing={2}
        >
          <Button variant="contained" onClick={applyFilter}>
            Apply
          </Button>
          <Button variant="contained" color="error" onClick={clearFilter}>
            Clear
          </Button>
        </Stack>
      </JumboScrollbar>
    </Drawer>
  );
};

export default AdvertiserFiltersCustomizer;
